import React, { PureComponent } from 'react';
import SliderLetters from '../../componets/slider';
import Button from '@material-ui/core/Button';

class HomeMobile extends PureComponent {
  render() {
    return (
      <section className="home-slider-mobile">
        <SliderLetters/>
        <Button className="animated fadeOutUp infinite go-down">
            <img src={process.env.PUBLIC_URL + '/assets/images/move.svg'} title="Move" alt="godown" />
        </Button>
      </section>
    )
  }
}

export default HomeMobile;